import React from 'react';
import DatePicker from 'react-datepicker';
import {Form, FormGroup, ControlLabel, Button } from 'react-bootstrap';

class FromToDateForm extends React.Component {
    render () {
        return (
            <Form inline onSubmit={this.props.handleSubmit}>
                <FormGroup controlId="formDateFrom">
                    <ControlLabel>Datum od:</ControlLabel>
                    {' '}
                    <DatePicker className="form-control"
                                selected={this.props.startDate}
                                selectsStart
                                startDate={this.props.startDate}
                                endDate={this.props.endDate}
                                onChange={this.props.handleChangeStart}
                    />
                </FormGroup>
                {' '}
                <FormGroup controlId="formDateTo">
                    <ControlLabel>Datum do:</ControlLabel>
                    {' '}
                    <DatePicker className="form-control"
                                selected={this.props.endDate}
                                selectsEnd
                                startDate={this.props.startDate}
                                endDate={this.props.endDate}
                                onChange={this.props.handleChangeEnd}
                    />
                </FormGroup>
                {' '}
                <Button type="submit" className="btn-primary atDatepicker">
                    Vybrat
                </Button>
            </Form>
        );
    }
}

export default FromToDateForm;


/** WEBPACK FOOTER **
 ** ./src/components/Forms/FromToDateForm.js
 **/